import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Button from 'components/Common/Button';
import { useNavigate } from 'react-router-dom'
import api from 'api'
import { Typography, Box } from '@mui/material';
import hourGlassIcon from 'assets/icons/Vector.svg'
import { styled } from '@mui/material/styles'

const SessionExpired = styled(Box)(({ theme }) => ({
  width: '400px',
  height: '250px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '25px',
}))

const SessionExpiredIcon = styled(Box)(({ theme }) => ({
  fontSize: '3rem',
  Width: '37.5px',
  Height: '43.75px',
  Top: '3.13px',
  Left: '6.25px',
  margin: '20px',
}))

const IdleTimer = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [showDialog, setshowDialog] = useState(false);
  const { maxIdleTime } = props

  let warnTimeout
  let logoutTimeout

  const warn = () => {
    // console.log('warn-signOut-onIdle')
  }

  const logout = () => {
    setshowDialog(true);
    dispatch({ type: 'userSignOut' })
    api.signOut();
  }

  // const destroy = () => {
  //   console.log('Session destroyed')
  // }

  const setTimeouts = () => {
    warnTimeout = setTimeout(warn, maxIdleTime)
    logoutTimeout = setTimeout(logout, maxIdleTime)
  }

  const clearTimeouts = () => {
    if (warnTimeout) clearTimeout(warnTimeout)
    if (logoutTimeout) clearTimeout(logoutTimeout)
  }

  useEffect(() => {
    // console.log('idletimer-started')
    const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress']

    const resetTimeout = () => {
      // console.log('idletimer-resetTimeout-maxIdleTime-', maxIdleTime)
      clearTimeouts()
      setTimeouts()
    }

    for (let i in events) {
      window.addEventListener(events[i], resetTimeout)
    }

    setTimeouts()
    return () => {
      // console.log('idletimer-removed')
      for (let i in events) {
        window.removeEventListener(events[i], resetTimeout)
        clearTimeouts()
      }
    }
    // eslint-disable-next-line
  }, [maxIdleTime])

  const handleClick = () => {
    navigate('/auth')
  }

  return (
    <Dialog open={showDialog} style={{ zIndex:2000}} PaperProps={{
      style: {
        borderRadius: '20px' 
      },
    }}>
      <DialogContent>
        <SessionExpired>
          <SessionExpiredIcon><img src={hourGlassIcon} alt="hourGlass" /></SessionExpiredIcon>
          <Typography variant='h5'>Your session has expired</Typography>
          <div><Button sx={{ width: '250px', marginTop: '20px' }} onClick={handleClick}>Sign Back In</Button></div>
        </SessionExpired>
      </DialogContent>
    </Dialog>
  )
}

export default IdleTimer
